export class Price {

    public static adapt(value: any) {
        const currency = value.currency;
        const currencySymbol = value.currencySymbol;
        const currentPrice = Number(value.currentPrice);
        const previousPrice = Number(value.previousPrice);
        return new Price(
            currency,
            currencySymbol,
            currentPrice,
            previousPrice,
        );
    }

    constructor(
        public currency: string,
        public currencySymbol: string,
        public currentPrice: number,
        public previousPrice: number,
    ) { }
}